import { axiosApi } from "../../../../../../../api/dbAxios";

export const fetchTeamSummary = async (
  regulatorCode: string | undefined,
  case_no: string | undefined,
) => {
  const test_email = "rborodinov@deloittece.com";
  try {
    const isLocalhost =
      typeof window !== "undefined" && window.location.hostname === "localhost";

    const response = await axiosApi.get(
      `/items/${regulatorCode}/${case_no}/team_summary`,
      {
        params: isLocalhost ? { test_email } : {},
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching Team Summary:", error);
    return {};
  }
};
